export default __webpack_public_path__ + "static/codeigniter_service_banner-8cc8fc815f2f6d901b3f4be92eb7a693.svg";